import React from 'react';
import { withSafeArea } from './safeArea';

export interface HomeIndicatorProps {
  darkOrScan?: boolean;
}

/** iOS-style home indicator bar (sits in document flow under the tab bar) */
export const HomeIndicator: React.FC<HomeIndicatorProps> = ({ darkOrScan }) => (
  <div
    className="pointer-events-none flex justify-center pt-1"
    style={{ paddingBottom: `max(${withSafeArea('bottom')}, 6px)` }}
  >
    <div
      className="h-[5px] w-[139px] rounded-full"
      style={{
        background: darkOrScan ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.25)',
      }}
    />
  </div>
);
